import { render, staticRenderFns } from "./sendmsglist.vue?vue&type=template&id=180c644f&scoped=true&"
import script from "./sendmsglist.vue?vue&type=script&lang=js&"
export * from "./sendmsglist.vue?vue&type=script&lang=js&"
import style0 from "./sendmsglist.vue?vue&type=style&index=0&id=180c644f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180c644f",
  null
  
)

export default component.exports